import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateJob } from "../redux/features/job/jobSlice";
import formatDate from "../utils/formatDate";

export default function EditJob() {
  const param = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { jobs, isLoading } = useSelector((state) => state.job);
  const jobList = jobs?.filter((job) => job.id === parseInt(param?.id));
  const editjob = jobList.length > 0 ? jobList[0] : {};

  const { id, title, type, salary, deadline } = editjob;

  const [updateTitle, setTitle] = useState(title);
  const [updateType, setType] = useState(type);
  const [updateSalary, setSalary] = useState(salary);
  const [updateDeadline, setDeadline] = useState(deadline);
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Did not go beyond, just added the required
    // You can check the utils/extra.js
    function validate() {
      const today = new Date().valueOf();
      const date = new Date(updateDeadline).valueOf();

      if (updateSalary < 0) {
        setMessage("Please insert a valid salary!");
        return false;
      }

      if (date <= today) {
        setMessage("Deadline requires an upcoming date!");
        return false;
      }
      if (
        updateTitle !== "" &&
        updateType !== "" &&
        updateSalary !== "" &&
        updateDeadline !== ""
      ) {
        return true;
      }
    }

    if (validate()) {
      dispatch(
        updateJob({
          id,
          data: {
            title: updateTitle,
            type: updateType,
            salary: Number(updateSalary),
            deadline: formatDate(updateDeadline),
          },
        })
      );

      navigate("/");
    }
  };

  return (
    <div className="lg:pl-[14rem] mt-[5.8125rem]">
      <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>

        <div className="max-w-3xl mx-auto">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label
                htmlFor="lws-JobTitle"
                className="text-sm font-medium text-slate-300"
              >
                Job Title
              </label>
              <select
                id="lws-JobTitle"
                name="lwsJobTitle"
                required
                value={updateTitle}
                onChange={(e) => setTitle(e.target.value)}
              >
                <option value="" hidden>
                  Select Job
                </option>
                <option>Software Engineer</option>
                <option>Software Developer</option>
                <option>Full Stack Developer</option>
                <option>MERN Stack Developer</option>
                <option>DevOps Engineer</option>
                <option>QA Engineer</option>
                <option>Product Manager</option>
                <option>Social Media Manager</option>
                <option>Senior Executive</option>
                <option>Junior Executive</option>
                <option>Android App Developer</option>
                <option>IOS App Developer</option>
                <option>Frontend Developer</option>
                <option>Frontend Engineer</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobType">Job Type</label>
              <select
                id="lws-JobType"
                name="lwsJobType"
                required
                value={updateType}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="" hidden>
                  Select Job Type
                </option>
                <option>Full Time</option>
                <option>Internship</option>
                <option>Remote</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobSalary">Salary</label>
              <div className="flex border rounded-md shadow-sm border-slate-600">
                <span className="input-tag">BDT</span>
                <input
                  type="number"
                  name="lwsJobSalary"
                  id="lws-JobSalary"
                  required
                  className="!rounded-l-none !border-0"
                  placeholder="20,00,000"
                  value={updateSalary}
                  onChange={(e) => setSalary(e.target.value)}
                />
              </div>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobDeadline">Deadline</label>
              <input
                type="date"
                name="lwsJobDeadline"
                id="lws-JobDeadline"
                required
                value={updateDeadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
            </div>

            <div className="text-right">
              <button
                type="submit"
                id="lws-submit"
                className="cursor-pointer btn btn-primary w-fit"
                disabled={isLoading}
              >
                Edit
              </button>
            </div>
            <p
              style={{
                color: message.includes("Job has been successfully added")
                  ? "yellow"
                  : "red",
              }}
            >
              {message}
            </p>
          </form>
        </div>
      </main>
    </div>
  );
}
